import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import notification from '../../services/notification';
import types from '../types';

export function* createOrder(payload) {
  try {
    const { data, status } = yield call(api.trading.createOrder, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.CREATE_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: types.CREATE_ORDER_FAILURE,
    });
    const errors = error?.response?.data?.errors;
    if (errors?.includes('create_order_unavailable')) {
      notification({
        type: 'error',
        title: 'Trade',
        message: 'Create order unavailable.',
      });
    }
    if (errors?.includes('first_you_must_verify_your_identity')) {
      notification({
        type: 'error',
        title: 'Trade',
        message: 'First you must verify your identity.',
      });
    }
  }
}

export function* createStopLimitOrder(payload) {
  try {
    const { data, status } = yield call(
      api.trading.createStopLimitOrder,
      payload,
    );

    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.CREATE_STOP_LIMIT_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: types.CREATE_STOP_LIMIT_ORDER_FAILURE,
    });
  }
}

export function* watcherCreateOrder() {
  yield takeLatest(types.CREATE_ORDER_START, createOrder);
}

export function* watcherCreateStopLimitOrder() {
  yield takeLatest(types.CREATE_STOP_LIMIT_ORDER_START, createStopLimitOrder);
}
